import { APP_STORE_SLICES } from "@/constants/app";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bulkUploadDiscountedPrice: null,
  bulkUploadShippingCost: null,
  bulkUploadMarketPickup: null,
  bulkUploadProcessingTime: null,
  bulkUploadProductQuantity: 1,
  bulkUploadSelectedItemCondition: null,
  bulkUploadSelectedDiscountProfile: null,
  bulkUploadScopeOfDelivery: null,
  bulkUploadSelectedProcess: null,
};

const bulkUploadOfferDetailsSlice = createSlice({
  name: APP_STORE_SLICES.BULK_UPLOAD.OFFER_DETAILS,
  initialState,
  reducers: {
    // setters
    setBulkUploadDiscountedPrice: (state, action) => {
      state.bulkUploadDiscountedPrice = action.payload;
    },
    setBulkUploadShippingCost: (state, action) => {
      state.bulkUploadShippingCost = action.payload;
    },
    setBulkUploadMarketPickup: (state, action) => {
      state.bulkUploadMarketPickup = action.payload;
    },
    setBulkUploadProcessingTime: (state, action) => {
      state.bulkUploadProcessingTime = action.payload;
    },
    setBulkUploadProductQuantity: (state, action) => {
      state.bulkUploadProductQuantity = action.payload;
    },
    setBulkUploadSelectedItemCondition: (state, action) => {
      state.bulkUploadSelectedItemCondition = action.payload;
    },
    setBulkUploadSelectedDiscountProfile: (state, action) => {
      state.bulkUploadSelectedDiscountProfile = action.payload;
    },
    setBulkUploadScopeOfDelivery: (state, action) => {
      state.bulkUploadScopeOfDelivery = action.payload;
    },
    setBulkUploadSelectedProcess: (state, action) => {
      state.bulkUploadSelectedProcess = action.payload;
    },
  },
});

export const {
  setBulkUploadDiscountedPrice,
  setBulkUploadShippingCost,
  setBulkUploadMarketPickup,
  setBulkUploadProcessingTime,
  setBulkUploadProductQuantity,
  setBulkUploadSelectedItemCondition,
  setBulkUploadSelectedDiscountProfile,
  setBulkUploadScopeOfDelivery,
  setBulkUploadSelectedProcess,
} = bulkUploadOfferDetailsSlice.actions;

// getters (selectors)
export const getBulkUploadDiscountedPrice = (state) =>
  state.bulkUploadOfferDetails.bulkUploadDiscountedPrice;

export const getBulkUploadShippingCost = (state) =>
  state.bulkUploadOfferDetails.bulkUploadShippingCost;

export const getBulkUploadMarketPickup = (state) =>
  state.bulkUploadOfferDetails.bulkUploadMarketPickup;

export const getBulkUploadProcessingTime = (state) =>
  state.bulkUploadOfferDetails.bulkUploadProcessingTime;

export const getBulkUploadProductQuantity = (state) =>
  state.bulkUploadOfferDetails.bulkUploadProductQuantity;

export const getBulkUploadSelectedItemCondition = (state) =>
  state.bulkUploadOfferDetails.bulkUploadSelectedItemCondition;

export const getBulkUploadSelectedDiscountProfile = (state) =>
  state.bulkUploadOfferDetails.bulkUploadSelectedDiscountProfile;

export const getBulkUploadScopeOfDelivery = (state) =>
  state.bulkUploadOfferDetails.bulkUploadScopeOfDelivery;
export const getBulkUploadSelectedProcess = (state) =>
  state.bulkUploadOfferDetails.bulkUploadSelectedProcess;

export default bulkUploadOfferDetailsSlice.reducer;
